import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../../shared/types/api.types'
import { getLockerOrderDetailsApi } from './getLockerOrderDetails.api'
import getLockerOrderDetailsInitialState from './getLockerOrderDetails.initialState'
import { GetLockerOrderDetailsErrorResponse, GetLockerOrderDetailsRequestPayload } from './getLockerOrderDetails.types'

export const getLockerOrderDetails = createAsyncThunk(
  urls.admin.getLockerOrderDetails,
  async (payload: GetLockerOrderDetailsRequestPayload, { rejectWithValue }) => {
    const { request, onSuccess } = payload

    try {
      const response = await getLockerOrderDetailsApi(request)

      onSuccess && onSuccess()

      return response
    } catch (error) {
      errorHandler.handleApiError(error as ApiErrorResponse)

      return rejectWithValue(error)
    }
  }
)

const getLockerOrderDetailsSlice = createSlice({
  name: urls.admin.getLockerOrderDetails,
  initialState: getLockerOrderDetailsInitialState,
  reducers: {
    resetGetLockerOrderDetails: (state) => {
      state.loading = false
      state.error = null
      state.success = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getLockerOrderDetails.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = null
      })
      .addCase(getLockerOrderDetails.fulfilled, (state, { payload }) => {
        state.loading = false
        state.success = payload
        state.error = null
      })
      .addCase(getLockerOrderDetails.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as GetLockerOrderDetailsErrorResponse
        state.success = null
      })
  }
})

export const { actions: getLockerOrderDetailsActions, reducer: getLockerOrderDetailsReducer } =
  getLockerOrderDetailsSlice
export const { resetGetLockerOrderDetails } = getLockerOrderDetailsActions
export default getLockerOrderDetailsSlice.reducer
